import { network } from 'lib/network';
import { IConfiguration } from 'stores/monitorStore';
import { RCOrganization } from 'types/coreEntites/Organization';
import { IOrganizationPaymentMethod } from 'types/payment';
import { Organization, PlatformsEnum, PaginationResultDto, Facility } from '@bondsports/types';
import { auth } from '../auth';

const apiUrl = process.env.BOND_SPORTS_API_URL;
const GOOGLE_API_KEY = process.env.GOOGLE_API_KEY;

// deprecated, instead use 'getOrganizationById'
async function getOrganizationData(organizationId: number): Promise<RCOrganization> {
	const response = await network.get(`${apiUrl}v1/organizations/${organizationId}`);

	return response.data;
}

function getOrganizationById(
	organizationId: number,
	initialHeaders?: { accept?: string; authorization?: string | null; 'Content-Type'?: string }
): Promise<{ data: RCOrganization | Organization }> {
	const { headers } = auth.getAuthHeaders();

	return network.get(`${apiUrl}v4/organization/${organizationId}`, { headers: { ...headers, ...initialHeaders } });
}

function getMonitorConfigurationById(organizationId: string, configurationId: string): Promise<IConfiguration> {
	return network.get(`${apiUrl}v4/monitor-config/organization/${organizationId}/id/${configurationId}`);
}

function getMonitorConfigurationByCode(code: string): Promise<IConfiguration> {
	return network.get(`${apiUrl}v4/monitor-config/code/${code}`);
}

function getOrganizationPaymentMethods(
	organizationId: number,
	platform: PlatformsEnum = PlatformsEnum.CONSUMER
): Promise<IOrganizationPaymentMethod[] | { err: string }> {
	const headers = auth.getAuthHeaders();
	return network.get(`${apiUrl}v4/organization/${organizationId}/payment-methods?platform=${platform}`, headers);
}

const getFacilitiesByOrganizationUserAndInvoiceIds = async (
	organizationId: number,
	userId: number,
	invoiceId: number,
	headers?: Record<string, unknown>
): Promise<PaginationResultDto<Facility>> => {
	headers ??= auth.getAuthHeaders();
	const response = await network.get(
		`${apiUrl}v4/facilities/organization/${organizationId}/users/${userId}/invoice/${invoiceId}`,
		headers
	);

	if (response.err) {
		throw response.err;
	}
	return response;
};

const getFacilities = async (organizationId: number, headers?: unknown) => {
	const h = headers ?? auth.getAuthHeaders().headers;
	const response = await network.get(`${apiUrl}v4/facilities/organization/${organizationId}`, {
		headers: h,
	});
	return response;
};

// TODO: remove when useOrganizationTimezone is in a shared library
const getOrganizationTimezone = async (organization?: Organization | RCOrganization): Promise<string | undefined> => {
	if ((organization as Organization)?.timezone) {
		return (organization as Organization)?.timezone;
	}
	const long: number = organization?.address?.geo.coordinates[0];
	const lat: number = organization?.address?.geo.coordinates[1];

	if (!long && !lat) {
		return;
	}

	const location: string = encodeURIComponent([lat, long].join(','));
	const timestamp: number = Date.now() / 1000;

	const response = await network.get(`https://maps.googleapis.com/maps/api/timezone/json?location=${location}&timestamp=${timestamp}&key=${GOOGLE_API_KEY}`);

	return response.timeZoneId;
}

export const organizationApi = {
	getOrganizationData,
	getMonitorConfigurationById,
	getMonitorConfigurationByCode,
	getOrganizationById,
	getOrganizationPaymentMethods,
	getFacilities,
	getFacilitiesByOrganizationUserAndInvoiceIds,
	getOrganizationTimezone
};
